module.exports = __webpack_public_path__ + "img/home.0cfe0576.png";